var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        staticStyle: { "padding-top": "80px" },
        attrs: { id: "navigationPlaceholder" },
      },
      [_c("AdminNavigationV2", { attrs: { tid: _vm.tid } })],
      1
    ),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("hr", {
      staticStyle: { "border-color": "#bbb", margin: "20px 0 30px" },
    }),
    _vm._v(" "),
    !_vm.workspaceCreated
      ? _c("div", { staticClass: "container" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", { attrs: { for: "Name" } }, [_vm._v("Name:")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.name,
                    expression: "name",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text", placeholder: "Name of workspace" },
                domProps: { value: _vm.name },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.name = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c("ValidationError", {
                attrs: { context: "Name", errors: _vm.validationErrors },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", { attrs: { for: "Description" } }, [
                _vm._v("Description:"),
              ]),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.description,
                    expression: "description",
                  },
                ],
                staticClass: "form-control",
                attrs: { placeholder: "Description of workspace" },
                domProps: { value: _vm.description },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.description = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c("ValidationError", {
                attrs: { context: "Description", errors: _vm.validationErrors },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", { attrs: { for: "StartupUrl" } }, [
                _vm._v("Startup url:"),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.startupUrl,
                    expression: "startupUrl",
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  placeholder: "Startup url - only for advanced scenarios",
                },
                domProps: { value: _vm.startupUrl },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.startupUrl = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c("ValidationError", {
                attrs: { context: "StartupUrl", errors: _vm.validationErrors },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.statusInitial || _vm.statusInvalid,
                  expression: "statusInitial || statusInvalid",
                },
              ],
              staticClass: "btn btn-primary btn-lg",
              attrs: { type: "button" },
              on: { click: _vm.handleCreateWorkspaceCommandV1 },
            },
            [_vm._v("Create")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.statusInvoking,
                  expression: "statusInvoking",
                },
              ],
              staticClass: "btn btn-primary btn-lg",
              attrs: { type: "button", disabled: "" },
            },
            [_vm._v("Creating...")]
          ),
        ])
      : _c("div", { staticClass: "container" }, [
          _c("h4", { staticClass: "fg-color-blue" }, [
            _vm._v("Workspace was created"),
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _vm.createdWorkspaceId
            ? _c("div", [
                _c(
                  "a",
                  {
                    staticClass: "btn btn-success text-white",
                    staticStyle: { padding: "0.7em 2em" },
                    attrs: {
                      href: `/#/admin/organizations/workspaces/manage/${_vm.createdWorkspaceId}`,
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-external-link",
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Manage workspace members")]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "h4",
                  {
                    staticClass: "fg-color-blue",
                    staticStyle: { margin: "20px 0" },
                  },
                  [_vm._v("or")]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-secondary text-white",
              staticStyle: { padding: "0.7em 2em" },
              on: { click: _vm.handleFinish },
            },
            [
              _c("i", {
                staticClass: "fa fa-workspace-plus",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Add another workspace")]),
            ]
          ),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-7" }, [
          _c(
            "h1",
            {
              staticStyle: {
                "font-size": "2em",
                "font-weight": "300",
                color: "#33475b",
              },
            },
            [_vm._v("Create a new workspace")]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-5 col-sm-6 text-right" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }